import { getOrganizationById } from '@services/queries/auth0';
import { RootState } from '@store/redux/store';
import { useQuery } from 'react-query';
import { OrgStates } from '../Organization.types';
import { cyRQKeyHelper } from '../utils/cyRQKeyHelper';
import { SetState } from '../utils/onOrgNameSubmit';

export function useOrgQuery(
  organization: RootState['organization'],
  orgFormState: OrgStates,
  setOrgFormState: SetState<OrgStates>,
) {
  const qKey = ['organization', organization.orgId];

  return useQuery(qKey, () => getOrganizationById(organization.orgId), {
    retry: false,
    // Using redux as source of truth for revisits only
    enabled: orgFormState === 'idle-revisit',
    onSuccess: () => {
      setOrgFormState('idle');
      cyRQKeyHelper('query-key-orgFromId', qKey);
    },
  });
}
